import { createPersistentEmitter } from 'src/lib/Emitter';
import { State } from 'src/state';

export default function statePromise(cb: (state: State) => boolean) {
  // Not resolved, so we need to wait for state change to resolve it later
  return new Promise<void>((resolve) => {
    const emitter = createPersistentEmitter(cb);
    const listener = (state: boolean) => {
      if (state) {
        emitter.removeListener(listener);
        resolve();
      }
    };

    emitter.addListener(listener);
  });
}

export function cancelableStatePromise(cb: (state: State) => boolean) {
  const emitter = createPersistentEmitter(cb);

  // Not resolved, so we need to wait for state change to resolve it later
  const promise = new Promise<void>((resolve) => {
    const listener = (state: boolean) => {
      if (state) {
        emitter.removeListener(listener);
        resolve();
      }
    };

    emitter.addListener(listener);
  });

  return {
    promise,
    cancel: () => emitter.detach(),
  };
}
